// web stub — offline mode (WatermelonDB sync) is native-only; the provider it reads
// from is mounted only in matrix-native, so on web there is no status to publish
export function useInitialiseOfflineModeStatus(): void {
  // no-op on web
}
